module.exports = __webpack_public_path__ + "img/jewelleryBackground.49bdebd.jpg";